import { render } from "./UserFeed.vue?vue&type=template&id=6d90704e&scoped=true"
import script from "./UserFeed.vue?vue&type=script&lang=ts"
export * from "./UserFeed.vue?vue&type=script&lang=ts"

import "./UserFeed.vue?vue&type=style&index=0&id=6d90704e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d90704e"

export default script